import React from 'react';

import { formatBackorderMessage } from './storeLogic/storeStateManager';

function CheckoutSummaryItem({item}) {
  const formattedSubtotal = parseFloat(item.subtotal).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const formattedQuantity = parseInt(item.quantity).toLocaleString('en-US');
  const backorderMessage = formatBackorderMessage(
    item.quantity,                    // requestedQuantity
    item.variantDetails.quantity,     // availableQuantity (variant stock)
    item.variantDetails.backordering, // productAllowsBackordering (variant property)
    item.variantDetails.downloadable  // isDownloadable (variant property)
  );
  const hasAttributes = item.variantDetails.attributes && Object.values(item.variantDetails.attributes).some(Boolean);
  const displayTitle = hasAttributes ?
    `${item.productDetails.title} - ${Object.values(item.variantDetails.attributes).join(' - ')}` :
    item.productDetails.title;

  return (
    <tr key={item.id}>
      <th>
        {displayTitle}
        {item.quantity > 1 && ` x ${formattedQuantity}`}
        {backorderMessage !== null &&
          <div className="backorder">{backorderMessage}</div>
        }
      </th>
      <td>{formattedSubtotal}</td>
    </tr>
  )
}

export default CheckoutSummaryItem